<template>
  <div />
</template>

<script>

/**
 * Vue: Customers Index (customers-index)
 * -----------------------------------------------------------------------------
 * Entry point for customer account portal
 *
 */
import { Splide } from '@splidejs/splide'

import { isVisible } from '~/helpers/general'
import { values as breakpoints } from '~/config/breakpoints'

export default {

  name: 'CustomersIndex',

  created() {
    this.initMobileNavigation()
  },

  methods: {

    /**
     * Initialize Splide for customer navigation using the JS method
     */
    initMobileNavigation() {
      const element = document.querySelector('[js-customer="navigation"]')

      if (!element) {
        return
      }

      const slides = [...element.querySelectorAll('[js-customer="navigation-slide"]')]
      const activeIndex = slides.findIndex(slide => slide.dataset.active === 'true')
      const activeSlide = slides[activeIndex]

      const splide = new Splide(element, {
        drag: true,
        wheel: true,
        arrows: false,
        pagination: false,
        gap: 'var(--spacing-l)',
        focus: 'left',
        mediaQuery: 'min',
        autoWidth: true,
        flickMaxPages: 1,
        flickPower: 250,
        breakpoints: {
          [breakpoints.l]: {
            destroy: true,
          },
        },
        padding: {
          left: 'var(--layout-margin)',
          right: 'var(--layout-margin)',
        },
        omitEnd: true,
      }).mount()

      if (!isVisible(activeSlide, { direction: 'x', partial: false })) {
        splide.go(activeIndex)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/components/splide';
</style>
